import React from 'react';

interface LoadingScreenProps {
  fullScreen?: boolean;
}

export function LoadingScreen({ fullScreen = false }: LoadingScreenProps) {
  const containerClasses = fullScreen
    ? 'min-h-screen flex items-center justify-center bg-gray-100'
    : 'flex items-center justify-center h-96';

  return (
    <div className={containerClasses}>
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black mx-auto mb-4"></div>
        <p className="text-gray-600">Se încarcă...</p>
      </div>
    </div>
  );
}
